module.exports = __webpack_public_path__ + "img/tiktok-shop-tokopedia.e0829627.webp";